import { Component, effect } from '@angular/core';
import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk';
import { DashboardService } from '../../../../services/dashboard.service';
import { UtilitiesService } from '../../../../services/utilities.service';
import { GlobalVariables } from '../../../../constants/global-constants';
import { SIMULATOR } from '../../../../../assets/i18n/simulator-translations';
import { environment } from '../../../../../environments/environment';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-simulator-dashboard',
  standalone: true,
  imports: [MatButtonModule,
    MatProgressSpinner,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule],
  templateUrl: './simulator-dashboard.component.html',
  styleUrl: './simulator-dashboard.component.scss'
})
export class SimulatorDashboardComponent {

embeddedDashboardExperience: QuickSightEmbedding.DashboardExperience;
  embedUrl: string;
  isLoading: boolean = true;
  isError: boolean = false;
  dashboardId: string;
  isDarkMode: boolean;
  parameterValue: number;

  themeArn: string;

  language: string;
  translations: any;

  isDemo: boolean = false;

  constructor(
    private dashboardService: DashboardService,
    private utilitiesService: UtilitiesService,
  ) {
    effect(() => {
      this.isDarkMode = this.utilitiesService.isDarkTheme();
      this.themeArn = this.isDarkMode ? GlobalVariables.midnight : GlobalVariables.classic;
      this.applyFilter();
    });
  }

  ngOnInit() {
    this.isDemo = this.utilitiesService.isDemoValue;
    this.isDarkMode = localStorage.getItem('theme') === GlobalVariables.darkTheme;
    this.themeArn = this.isDarkMode ? GlobalVariables.midnight : GlobalVariables.classic;
    this.language = localStorage.getItem('locale');
    this.translations = SIMULATOR[this.language] || SIMULATOR["en-us"];
    this.isDemo = this.utilitiesService.isDemoValue;
    this.getDashboardId();
  }

  formatLocale(locale: string): string {
    if (locale) {
      return locale.toLowerCase().replace(/^([a-z])/, (match) => match.toUpperCase());
    }
    return 'en-EN'
  }

  getDashboardId() {
    this.dashboardId = environment.savingsCalculatorDashboardId;
    this.getQuicksightEmbedURL(this.dashboardId);
  }

  getQuicksightEmbedURL(dashboardId: string) {
    this.dashboardService.getQuicksightEmbedURL(dashboardId).subscribe({
      next: (res: any) => {
        if (res) {
          this.embedUrl = res.EmbedUrl;
          this.embedVisual();
        }
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  //Quicksight Embedding
  async embedVisual() {
    const {
      createEmbeddingContext,
    } = QuickSightEmbedding;

    const embeddingContext = await createEmbeddingContext({
      onChange: (changeEvent, metadata) => {
        console.log('Context received a change', changeEvent, metadata);
      },
    });

    const frameOptions = {
      url: this.embedUrl,
      container: '#quicksight-dashboard',
      height: "100%",
      width: "100%"
    };

   /* const translationParams = Object.entries(this.translations).map(([key, value]) => ({
      Name: key,
      Values: [value]
    })); */

    const lang = this.formatLocale(this.language)


    const contentOptions = {
      parameters: [
      
      ],
      locale: lang,
      themeOptions: {
        themeArn: this.themeArn
      },
      onMessage: async (messageEvent) => {
        switch (messageEvent.eventName) {
          case 'CONTENT_LOADED': {
            this.isLoading = false;
            break;
          }
          case 'ERROR_OCCURRED': {
            this.isError = true;
            this.isLoading = false;
            break;
          }
        }
      },
    };


    //@ts-ignore
    this.embeddedDashboardExperience = await embeddingContext.embedDashboard(frameOptions, contentOptions);
  };


  applyFilter() {
    this.embeddedDashboardExperience?.setTheme(this.themeArn);
  }
}


